import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Table, Button, Flex, Spin, message } from "antd";
import APIService from "../../Service/APIService";
import Config from "../../Config/Config";
import {
  ExclamationCircleFilled,
  CheckCircleFilled,
  PlusOutlined,
  DownloadOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { colors } from "../../theme/colors";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import TableOptionsCell from "../../common/table/table-options-cell";
import CommonTable from "../../common/table";
import TableLink from "../../common/table/table-link";

const components = {
  header: {
    cell: ({ style, ...restProps }) => (
      <th
        {...restProps}
        style={{
          ...style,
          backgroundColor: "#000a7b",
          color: "#fff",
        }}
      />
    ),
  },
};

const ReferralContractsDashboard = () => {
  const { id } = useParams();
  const [columns, setColumns] = useState([]);
  const [referralContracts, setReferralContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const userData = user;

  const getReferralContracts = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getreferralcontractsbydistid?DistID=${id}`
    );
    const newData = response?.data?.data.map((item, index) => ({
      ...item,
      // remove time from start date and end date
      StartDate: item.StartDate.split("T")[0],
      EndDate: item?.EndDate ? item.EndDate.split("T")[0] : null,
    }));
    setReferralContracts(newData);
  };

  const generateSchema = () => {
    const schema = Config.ColumnConfigs.DistributorReferralContracts;
    const columns = [];
    for (const cur of schema) {
      if (
        cur.isDisplayed &&
        cur.isSearchable &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        // console.log("Inside AccountName Column");
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (
              typeof (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : "0" || 0) === "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              console.log("backend name: ", cur.backendName);
              console.log("strng total: ", a[`${cur.backendName}`]);
              console.log(
                "total: ",
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
              return (
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                ) -
                Number(
                  b[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            } else {
              console.log("invalid");
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (
        cur.isDisplayed &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (
              typeof (a[`${cur.backendName}`] ? a[`${cur.backendName}`] : 0) ===
              "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              return (
                a[`${cur.backendName}`].replace("$", "").replace(",", "") -
                b[`${cur.backendName}`].replace("$", "").replace(",", "")
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (cur.isDisplayed && cur.isSpecial) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
        });
      } else if (cur.isDisplayed && cur.isFormatter) {
        const obj = createFormatter(cur);
        columns.push(obj);
      }
    }
    console.log("Columns: ", columns);
    return columns;
  };

  console.log(referralContracts, "referralContracts >>>> 1");

  const handleDownload = async (record) => {
    console.log(record, "referralContracts >>>> 2");
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(record.AzureBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // const downFile = record?.UploadContract;
    // const arrayBuffer = downFile.data;
    // const bytes = new Uint8Array(arrayBuffer);
    // const blob = new Blob([bytes], { type: "application/pdf" });
    // const link = document.createElement("a");
    // const b = blob;
    // let url = null;
    // url = window.URL.createObjectURL(b);
    // link.href = url;
    // link.setAttribute("download", (record?.UploadContractFilename ?? "ReferralContract.pdf")); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const createFormatter = (cur) => {
    return {
      title: cur.displayName,
      dataIndex: cur.backendName,
      key: cur.backendName,
      render: (index, record) => (
        <div style={{ display: "flex" }}>
          {record?.UploadContract && hasPermission(userData, "dist_contract.view") && (
            <DownloadOutlined
              style={{ fontSize: "24px", marginLeft: "16px" }}
              onClick={() => handleDownload(record)}
            />
          )}
          {hasPermission(userData, "dist_contract.view") && (
            <Button
              type="primary"
              style={{ background: "#ff9202", marginLeft: "10px" }}
            >
              <Link to={`/DistributorReferralContract/${record.ID}`}>View</Link>
            </Button>
          )}
        </div>
      ),
    };
  };

  const tableHeadersDistRefferralContracts = [
    {
      headerName: "Referree Distributor",
      field: "RefereeDistributorName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.RefereeDistributorName}
          path={`/Distributor/${params.data.RefereeDistributorID}`}
        />
      ),
    },
    {
      headerName: "Start Date",
      field: "StartDate",
      filter: true,
    },
    {
      headerName: "End Date",
      field: "EndDate",
      filter: true,
    },
    {
      headerName: "Created By",
      field: "CreatedBy",
      filter: true,
    },
    {
      headerName: "Options",
      field: "",
      sortable: false,
      cellRenderer: (params) => {
        const canView = hasPermission(userData, "dist_contract.view");
        return (
          <TableOptionsCell
            optionOne={canView ? "Download" : undefined}
            optionOneType={canView ? "primary" : undefined}
            optionOneClickFn={canView ? async () => await handleDownload(params.data) : undefined}
            optionTwo={canView ? "View" : undefined}
            optionTwoType={canView ? "primary" : undefined}
            optionTwoClickPath={canView ? `/DistributorReferralContract/${params.data.ID}` : undefined}
          />
        );
      },
    },
  ];

  useEffect(() => {
    setColumns(generateSchema());
    getReferralContracts().then(() => {
      setLoading(false);
    });
  }, []);

  return (
    <div>
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      {/* <Table
        columns={columns}
        dataSource={referralContracts}
        components={components}
      /> */}
      <CommonTable
        rowData={referralContracts}
        columnDefs={tableHeadersDistRefferralContracts}
      />
      <div style={{ display: "flex", justifyContent: "left" }}>
        {userData.Type === "Admin" && hasPermission(userData, "dist_contract.edit") && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            style={{
              background: colors["primaryColor"],
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <Link to={"/DistributorReferralContract"}>New Contract</Link>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ReferralContractsDashboard;
